import { isEmpty as _isEmpty, sortBy } from 'lodash'

export const alphabeticallySortObjectsBasedOnKey = (obj, key) => {
  return sortBy(obj, key)
}

export function isEmpty(object) {
  return _isEmpty(object)
}
